import classes from './classes.json';
import monsters from './monsters.json';
import events from './events.json';
import areas from './areas.json';
import status from './status.json';
import changelog from './changelog.json';
import keywords from './keywords.json';
import versions from './versions.json';
import affixes from './affixes.json';
import addedbyevent from './addedbyevent.json';

export const DATA_CLASSES = classes;
export const DATA_MONSTERS = monsters;
export const DATA_EVENTS = events;
export const DATA_AREAS = areas;
export const DATA_STATUS = status;
export const DATA_CHANGELOG = changelog;
export const DATA_KEYWORDS = keywords;
export const DATA_VERSIONS = versions;
export const DATA_AFFIXES = affixes;
export const DATA_ADDED_BY_EVENT = addedbyevent;